// extracted by mini-css-extract-plugin
module.exports = {"form":"AddressForm_form__1kxu8","output":"AddressForm_output__y1qZn","output_label":"AddressForm_output_label__37HUZ"};